import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../../types/api';
import { SitterBranchWorker } from '../../types/branch/SitterBranchWorker';

const URL = '/v2/sitter-branch-workers';

class SitterBranchWorkerService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<SitterBranchWorker>> {
    return axios.get(URL, config);
  }
}

export { SitterBranchWorkerService };
